export default __webpack_public_path__ + "static/media/documentsIcon.5d213961.svg";